var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 216 216",
    style: {
      enableBackground: "new 0 0 216 216"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.1,
    y: 1.9,
    className: "st0",
    width: 214.9,
    height: 214.9
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.1,
    y: 1.9,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.7,
    y: 1.9,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.3,
    y: 1.9,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.9,
    y: 1.9,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.5,
    y: 1.9,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.1,
    y: 1.9,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.7,
    y: 1.9,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.1,
    y: 1.9,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.3,
    y: 1.9,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.9,
    y: 1.9,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.6,
    y: 1.9,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.8,
    y: 1.9,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.4,
    y: 1.9,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 1.9,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.6,
    y: 1.9,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.2,
    y: 1.9,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.8,
    y: 1.9,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.4,
    y: 1.9,
    width: 8.6,
    height: 8.6
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.1,
    y: 10.5,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.7,
    y: 10.5,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.9,
    y: 10.5,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.1,
    y: 10.5,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.5,
    y: 10.5,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: 10.5,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.6,
    y: 10.5,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.8,
    y: 10.5,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.4,
    y: 10.5,
    width: 8.6,
    height: 8.6
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.1,
    y: 19.1,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.3,
    y: 19.1,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.9,
    y: 19.1,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.5,
    y: 19.1,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.7,
    y: 19.1,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.3,
    y: 19.1,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.6,
    y: 19.1,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.8,
    y: 19.1,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 19.1,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.6,
    y: 19.1,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.2,
    y: 19.1,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.4,
    y: 19.1,
    width: 8.6,
    height: 8.6
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.1,
    y: 27.7,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.3,
    y: 27.7,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.9,
    y: 27.7,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.5,
    y: 27.7,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.7,
    y: 27.7,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.9,
    y: 27.7,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.5,
    y: 27.7,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.1,
    y: 27.7,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.3,
    y: 27.7,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.9,
    y: 27.7,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.5,
    y: 27.7,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.8,
    y: 27.7,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 27.7,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.6,
    y: 27.7,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.2,
    y: 27.7,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.4,
    y: 27.7,
    width: 8.6,
    height: 8.6
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.1,
    y: 36.3,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.3,
    y: 36.3,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.9,
    y: 36.3,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.5,
    y: 36.3,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.7,
    y: 36.3,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.5,
    y: 36.3,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.9,
    y: 36.3,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.6,
    y: 36.3,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.8,
    y: 36.3,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 36.3,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.6,
    y: 36.3,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.2,
    y: 36.3,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.4,
    y: 36.3,
    width: 8.6,
    height: 8.6
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.1,
    y: 44.9,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.7,
    y: 44.9,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.9,
    y: 44.9,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.5,
    y: 44.9,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.7,
    y: 44.9,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.3,
    y: 44.9,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: 44.9,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.8,
    y: 44.9,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.4,
    y: 44.9,
    width: 8.6,
    height: 8.6
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.1,
    y: 53.5,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.7,
    y: 53.5,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.3,
    y: 53.5,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.9,
    y: 53.5,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.5,
    y: 53.5,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.1,
    y: 53.5,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.7,
    y: 53.5,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.9,
    y: 53.5,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.1,
    y: 53.5,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.3,
    y: 53.5,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.5,
    y: 53.5,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.6,
    y: 53.5,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.8,
    y: 53.5,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.4,
    y: 53.5,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 53.5,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.6,
    y: 53.5,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.2,
    y: 53.5,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.8,
    y: 53.5,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.4,
    y: 53.5,
    width: 8.6,
    height: 8.6
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 77.5,
    y: 62.1,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.1,
    y: 62.1,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.7,
    y: 62.1,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.5,
    y: 62.1,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.6,
    y: 62.1,
    width: 8.6,
    height: 8.6
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.1,
    y: 70.7,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.7,
    y: 70.7,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.3,
    y: 70.7,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.9,
    y: 70.7,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.5,
    y: 70.7,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.7,
    y: 70.7,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.3,
    y: 70.7,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.9,
    y: 70.7,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.5,
    y: 70.7,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.7,
    y: 70.7,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.9,
    y: 70.7,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.5,
    y: 70.7,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.2,
    y: 70.7,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.4,
    y: 70.7,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.6,
    y: 70.7,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.8,
    y: 70.7,
    width: 8.6,
    height: 8.6
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 8.7,
    y: 79.3,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.5,
    y: 79.3,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.1,
    y: 79.3,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.3,
    y: 79.3,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.9,
    y: 79.3,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.1,
    y: 79.3,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.3,
    y: 79.3,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.9,
    y: 79.3,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.6,
    y: 79.3,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.2,
    y: 79.3,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.4,
    y: 79.3,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.8,
    y: 79.3,
    width: 8.6,
    height: 8.6
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 25.9,
    y: 87.9,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.5,
    y: 87.9,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.1,
    y: 87.9,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.7,
    y: 87.9,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.3,
    y: 87.9,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.1,
    y: 87.9,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: 87.9,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.2,
    y: 87.9,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.8,
    y: 87.9,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.4,
    y: 87.9,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 87.9,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.6,
    y: 87.9,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.8,
    y: 87.9,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.4,
    y: 87.9,
    width: 8.6,
    height: 8.6
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.1,
    y: 96.5,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.7,
    y: 96.5,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.3,
    y: 96.5,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.9,
    y: 96.5,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.5,
    y: 96.5,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.1,
    y: 96.5,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.3,
    y: 96.5,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.5,
    y: 96.5,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.6,
    y: 96.5,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.2,
    y: 96.5,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.4,
    y: 96.5,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.4,
    y: 96.5,
    width: 8.6,
    height: 8.6
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 34.5,
    y: 105.1,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.7,
    y: 105.1,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.5,
    y: 105.1,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.1,
    y: 105.1,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.3,
    y: 105.1,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.9,
    y: 105.1,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.2,
    y: 105.1,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.8,
    y: 105.1,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.4,
    y: 105.1,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 105.1,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.2,
    y: 105.1,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.8,
    y: 105.1,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.4,
    y: 105.1,
    width: 8.6,
    height: 8.6
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.1,
    y: 113.7,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.3,
    y: 113.7,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.9,
    y: 113.7,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.3,
    y: 113.7,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.5,
    y: 113.7,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.9,
    y: 113.7,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.6,
    y: 113.7,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.2,
    y: 113.7,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.4,
    y: 113.7,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.6,
    y: 113.7,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.8,
    y: 113.7,
    width: 8.6,
    height: 8.6
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.1,
    y: 122.3,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.9,
    y: 122.3,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.5,
    y: 122.3,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.7,
    y: 122.3,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.3,
    y: 122.3,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.9,
    y: 122.3,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.5,
    y: 122.3,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.7,
    y: 122.3,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.3,
    y: 122.3,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.9,
    y: 122.3,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.5,
    y: 122.3,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: 122.3,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.6,
    y: 122.3,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.2,
    y: 122.3,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.8,
    y: 122.3,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.4,
    y: 122.3,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 122.3,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.6,
    y: 122.3,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.8,
    y: 122.3,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.4,
    y: 122.3,
    width: 8.6,
    height: 8.6
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.1,
    y: 130.9,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.5,
    y: 130.9,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.1,
    y: 130.9,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.3,
    y: 130.9,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.5,
    y: 130.9,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.1,
    y: 130.9,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.7,
    y: 130.9,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: 130.9,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.2,
    y: 130.9,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.4,
    y: 130.9,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 130.9,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.4,
    y: 130.9,
    width: 8.6,
    height: 8.6
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.1,
    y: 139.5,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.3,
    y: 139.5,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.5,
    y: 139.5,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.1,
    y: 139.5,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.7,
    y: 139.5,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.7,
    y: 139.5,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.3,
    y: 139.5,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.9,
    y: 139.5,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.5,
    y: 139.5,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: 139.5,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.6,
    y: 139.5,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.2,
    y: 139.5,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.8,
    y: 139.5,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.4,
    y: 139.5,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 139.5,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.2,
    y: 139.5,
    width: 8.6,
    height: 8.6
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 68.9,
    y: 148.1,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.5,
    y: 148.1,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.1,
    y: 148.1,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.3,
    y: 148.1,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: 148.1,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.6,
    y: 148.1,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 148.1,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.6,
    y: 148.1,
    width: 8.6,
    height: 8.6
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.1,
    y: 156.6,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.7,
    y: 156.6,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.3,
    y: 156.6,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.9,
    y: 156.6,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.5,
    y: 156.6,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.1,
    y: 156.6,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.7,
    y: 156.6,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.9,
    y: 156.6,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.9,
    y: 156.6,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.6,
    y: 156.6,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.8,
    y: 156.6,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 156.6,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.2,
    y: 156.6,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.8,
    y: 156.6,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.4,
    y: 156.6,
    width: 8.6,
    height: 8.6
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.1,
    y: 165.2,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.7,
    y: 165.2,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.1,
    y: 165.2,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.7,
    y: 165.2,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.5,
    y: 165.2,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.6,
    y: 165.2,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 165.2,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.6,
    y: 165.2,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.8,
    y: 165.2,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.4,
    y: 165.2,
    width: 8.6,
    height: 8.6
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.1,
    y: 173.8,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.3,
    y: 173.8,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.9,
    y: 173.8,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.5,
    y: 173.8,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.7,
    y: 173.8,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.9,
    y: 173.8,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.7,
    y: 173.8,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.3,
    y: 173.8,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.9,
    y: 173.8,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.5,
    y: 173.8,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: 173.8,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.6,
    y: 173.8,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.2,
    y: 173.8,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.8,
    y: 173.8,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.4,
    y: 173.8,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 173.8,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.2,
    y: 173.8,
    width: 8.6,
    height: 8.6
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.1,
    y: 182.4,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.3,
    y: 182.4,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.9,
    y: 182.4,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.5,
    y: 182.4,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.7,
    y: 182.4,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.9,
    y: 182.4,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.1,
    y: 182.4,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.7,
    y: 182.4,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.3,
    y: 182.4,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.9,
    y: 182.4,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.6,
    y: 182.4,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.8,
    y: 182.4,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 182.4,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.6,
    y: 182.4,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.2,
    y: 182.4,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.8,
    y: 182.4,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.4,
    y: 182.4,
    width: 8.6,
    height: 8.6
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.1,
    y: 191,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.3,
    y: 191,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.9,
    y: 191,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.5,
    y: 191,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.7,
    y: 191,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.9,
    y: 191,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.5,
    y: 191,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.1,
    y: 191,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.9,
    y: 191,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.5,
    y: 191,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: 191,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.6,
    y: 191,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.2,
    y: 191,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.4,
    y: 191,
    width: 8.6,
    height: 8.6
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.1,
    y: 199.6,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.7,
    y: 199.6,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.9,
    y: 199.6,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.1,
    y: 199.6,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.5,
    y: 199.6,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: 199.6,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.6,
    y: 199.6,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.2,
    y: 199.6,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.4,
    y: 199.6,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 199.6,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.6,
    y: 199.6,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.4,
    y: 199.6,
    width: 8.6,
    height: 8.6
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.1,
    y: 208.2,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.7,
    y: 208.2,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.3,
    y: 208.2,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.9,
    y: 208.2,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.5,
    y: 208.2,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.1,
    y: 208.2,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.7,
    y: 208.2,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.9,
    y: 208.2,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.7,
    y: 208.2,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.3,
    y: 208.2,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.9,
    y: 208.2,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.5,
    y: 208.2,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.4,
    y: 208.2,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 208.2,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.6,
    y: 208.2,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.2,
    y: 208.2,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.8,
    y: 208.2,
    width: 8.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.4,
    y: 208.2,
    width: 8.6,
    height: 8.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/qr.cc819618ed1cd4238100c013eca2dbb5.svg";
export { ForwardRef as ReactComponent };